/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { getUser, refreshPage, removeUserSession } from "../../Helpers/Utils/Common";
import { getFullNameUser, getRole, getPermissions } from "../../Helpers/Utils/Common";
import MenuItem from "./MenuItem";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { logoutUser, resyncData, recordUserActivityLog } from "../../Helpers/apiCalls/authApi";
import {
    Button,
    Modal,
    Spin,
    Row,
} from "antd";
import Title from "antd/es/typography/Title";

//css
import "./NavbarAdmin.css"

//icons
import logout from "../../Assets/Images/logout.png"
import kaffeAldeLogo from "../../Assets/Images/logo.png"
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import DescriptionIcon from '@mui/icons-material/Description';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CategoryIcon from '@mui/icons-material/Category';
import DiscountIcon from '@mui/icons-material/Discount';
import PeopleIcon from '@mui/icons-material/People';
import PaidIcon from '@mui/icons-material/Paid';


const NavbarAdmin = (props) => {
    const navigate = useNavigate();
    const permission = getPermissions();
    const userRole = getRole();

    const [showLoader, setShowLoader] = useState(false);

      // logout handler
    async function handleResync() {
        setShowLoader(true)
        recordUserActivityLog(
            `Clicked Resync Button`
        );
        const response = await resyncData();
        if (response.data) {
            recordUserActivityLog(
                `Resync Successfully`
            );
            toast.success(response.data)
        } else {
            recordUserActivityLog(
                `Error Resync`
            );
            toast.error('Error occurred! Please Resync Again!')
        }
        setShowLoader(false)
    }

    //ADMIN
    const adminManagerItems = [
        
        {
            name: "Closed Invoices",
            exact: true,
            to: "/closedinvoices",
            iconClassName: <DescriptionIcon/> ,
            expand: true,
        },
        {
            name: "Menus",
            exact: true,
            to: "/menuManager",
            iconClassName: <MenuBookIcon/>,
            expand: true,
        },
        {
            name: "Reports",
            exact: true,
            to: "/",
            iconClassName: <AssessmentIcon/>,
            subMenus: [
                // { name: "Sales", to: "/sales-report" },
                // { name: "Receiving Report", to: "/receiving-report" },
                {name: "Category Report", to: "/category-report"},
                {name: "Modifier Report", to: "/modifier-report"},
                {name: "EJournal", to: "/ejournal-report"},  
                { name: "Sales", to: "/sales-report" },
                { name: "Payment Report", to: "/payment-report" },
                { name: "Item History", to: "/item-history-report" },
                { name: "Senior Citizen Sales", to: "/senior-discounts-sales-report" },
                { name: "PWD Sales", to: "/pwd-discounts-sales-report" },
                { name: "Other Discount Sales", to: "/other-discounts-sales-report" },
                { name: "Cancelled Reports", to: "/cancelled-report" },
                { name: "Cash Counts", to: "/cash-counts-report" },
                { name: "Audit Trails", to: "/audit-trails-report" },
                { name: "Cashier Sales", to: "/x-reading-report" },
                { name: "Financial Report", to: "/z-reading-report" },
                { name: "Daily Sales Report", to: "/daily-sales-report" },
                
            ],
            expand: true,
        },
        // {
        //     name: "Receiving Report",
        //     exact: true,
        //     to: "/inventoryManager",
        //     iconClassName: receiving,
        //     expand: true,
        // },
        {
            name: "Categories",
            exact: true,
            to: "/categoryManager",
            iconClassName: <CategoryIcon/>,
            expand: true,
        },
        // {
        //     name: "Remarks",
        //     exact: true,
        //     to: "/remarksManager",
        //     iconClassName: paperclip,
        //     expand: true,
        // },

        {
            name: "Discounts",
            exact: true,
            to: "/discountsManager",
            iconClassName: <DiscountIcon/>,
            expand: true,
        },
        // {
        //     name: "Tax",
        //     exact: true,
        //     to: "/taxManager",
        //     iconClassName: tax,
        //     expand: true,
        // },

        {
            name: "Users",
            exact: true,
            to: "/userManager",
            iconClassName: <PeopleIcon/>,
            expand: true,
        },
        // {
        //     name: "Roles",
        //     exact: true,
        //     to: "/rolesManager",
        //     iconClassName: role,
        //     expand: true,
        // },
        // process.env.REACT_APP_LOCAL !== 'https://smash-pos-api.qrave.ph/' && {
        //     name: "Ordering Station",
        //     exact: true,
        //     to: "/orderingpage",
        //     iconClassName: <ShoppingCartIcon/>,
        //     expand: true,
        // },
    ];


    const cashierItems = [
        {
            name: "Cash Count",
            exact: true,
            to: "/cash-count",
            iconClassName: <PaidIcon/>,
            expand: true,
        },
        // {
        //     name: "Reports",
        //     exact: true,
        //     to: "/",
        //     iconClassName: file,
        //     subMenus: [
        //         { name: "Item History", to: "/item-history-report" },
        //         { name: "Hourly Sales", to: "/pwd-discounts-report" },
        //         { name: "Terminal Sales", to: "/audit-trails-report" },
        //         { name: "X Reading", to: "/x-reading-report" },
        //         { name: "Z Reading", to: "/z-reading-report" },
                
        //     ],
        //     expand: true,
        // },
        {
            name: "Reports",
            exact: true,
            to: "/",
            iconClassName: <AssessmentIcon/>,
            subMenus: [
                { name: "Cash Counts", to: "/cash-counts-report" },
                { name: "Sales", to: "/sales-report" },
                { name: "Item History", to: "/item-history-report" },
                { name: "QR & Manual Count", to: "/qr-manual-count-report" },
                { name: "Senior Citizen Sales", to: "/senior-discounts-report" },
                { name: "PWD Sales", to: "/pwd-discounts-report" },
                { name: "Other Disocunt Sales", to: "/other-discounts-report" },
                { name: "Audit Trails", to: "/audit-trails-report" },
                { name: "Cashier Sales", to: "/x-reading-report" },
                { name: "Financial Report", to: "/z-reading-report" },
                { name: "Daily Sales Report", to: "/daily-sales-report" },                
            ],
            expand: true,
        },
    ];

    const cashierItemsWOReports = [
        {
            name: "Cash Count",
            exact: true,
            to: "/cash-count",
            iconClassName: <PaidIcon/>,
            expand: true,
        },
    ];

    const principalUsers = [
        {
            name: "Reports",
            exact: true,
            to: "/",
            iconClassName: <AssessmentIcon/>,
            subMenus: [
                {name: "Category Report", to: "/category-report"},
                { name: "Sales", to: "/sales-report" },
                { name: "Item History", to: "/item-history-report" },
                { name: "Cashier Sales", to: "/x-reading-report" },
            ],
            expand: true,
        },
    ];

    const supervisorItems = [
        {
            name: "Closed Invoices",
            exact: true,
            to: "/closedinvoices",
            iconClassName: <DescriptionIcon/> ,
            expand: true,
        },
        // {
        //     name: "Menus",
        //     exact: true,
        //     to: "/menuManager",
        //     iconClassName: <MenuBookIcon/>,
        //     expand: true,
        // },
        {
            name: "Reports",
            exact: true,
            to: "/",
            iconClassName: <AssessmentIcon/>,
            subMenus: [
                // { name: "Sales", to: "/sales-report" },
                // { name: "Receiving Report", to: "/receiving-report" },
                // {name: "Category Report", to: "/category-report"},
                // {name: "EJournal", to: "/ejournal-report"},  
                // { name: "Sales", to: "/sales-report" },
                // { name: "Payment Report", to: "/payment-report" },
                // { name: "Item History", to: "/item-history-report" },
                // { name: "Senior Citizen Sales", to: "/senior-discounts-sales-report" },
                // { name: "PWD Sales", to: "/pwd-discounts-sales-report" },
                // { name: "Other Discount Sales", to: "/other-discounts-sales-report" },
                // { name: "Cancelled Reports", to: "/cancelled-report" },
                // { name: "Cash Counts", to: "/cash-counts-report" },
                // { name: "Audit Trails", to: "/audit-trails-report" },
                { name: "Cashier Sales", to: "/x-reading-report" },
                // { name: "Financial Report", to: "/z-reading-report" },
                
            ],
            expand: true,
        },
        // {
        //     name: "Receiving Report",
        //     exact: true,
        //     to: "/inventoryManager",
        //     iconClassName: receiving,
        //     expand: true,
        // },
        // {
        //     name: "Categories",
        //     exact: true,
        //     to: "/categoryManager",
        //     iconClassName: <CategoryIcon/>,
        //     expand: true,
        // },
        // {
        //     name: "Remarks",
        //     exact: true,
        //     to: "/remarksManager",
        //     iconClassName: paperclip,
        //     expand: true,
        // },

        // {
        //     name: "Discounts",
        //     exact: true,
        //     to: "/discountsManager",
        //     iconClassName: <DiscountIcon/>,
        //     expand: true,
        // },
        // {
        //     name: "Tax",
        //     exact: true,
        //     to: "/taxManager",
        //     iconClassName: tax,
        //     expand: true,
        // },

        // {
        //     name: "Users",
        //     exact: true,
        //     to: "/userManager",
        //     iconClassName: <PeopleIcon/>,
        //     expand: true,
        // },
        // {
        //     name: "Roles",
        //     exact: true,
        //     to: "/rolesManager",
        //     iconClassName: role,
        //     expand: true,
        // },
        ...(process.env.REACT_APP_LOCAL !== 'https://smash-pos-api.qrave.ph/'
            ? [
                {
                    name: "Ordering Station",
                    exact: true,
                    to: "/orderingpage",
                    iconClassName: <ShoppingCartIcon />,
                    expand: true,
                },
              ]
            : []),
    ];
     const supervisorExclusiveUser = [
        {
            name: "Closed Invoices",
            exact: true,
            to: "/closedinvoices",
            iconClassName: <DescriptionIcon/> ,
            expand: true,
        },
        {
            name: "Menus",
            exact: true,
            to: "/menuManager",
            iconClassName: <MenuBookIcon/>,
            expand: true,
        },
        {
            name: "Reports",
            exact: true,
            to: "/",
            iconClassName: <AssessmentIcon/>,
            subMenus: [
                { name: "Sales", to: "/sales-report" },
                // { name: "Receiving Report", to: "/receiving-report" },
                {name: "Category Report", to: "/category-report"},
                // {name: "EJournal", to: "/ejournal-report"},  
                // { name: "Sales", to: "/sales-report" },
                // { name: "Payment Report", to: "/payment-report" },
                // { name: "Item History", to: "/item-history-report" },
                // { name: "Senior Citizen Sales", to: "/senior-discounts-sales-report" },
                // { name: "PWD Sales", to: "/pwd-discounts-sales-report" },
                // { name: "Other Discount Sales", to: "/other-discounts-sales-report" },
                // { name: "Cancelled Reports", to: "/cancelled-report" },
                // { name: "Cash Counts", to: "/cash-counts-report" },
                // { name: "Audit Trails", to: "/audit-trails-report" },
                { name: "Cashier Sales", to: "/x-reading-report" },
                // { name: "Financial Report", to: "/z-reading-report" },
                
            ],
            expand: true,
        },
        // {
        //     name: "Receiving Report",
        //     exact: true,
        //     to: "/inventoryManager",
        //     iconClassName: receiving,
        //     expand: true,
        // },
        // {
        //     name: "Categories",
        //     exact: true,
        //     to: "/categoryManager",
        //     iconClassName: <CategoryIcon/>,
        //     expand: true,
        // },
        // {
        //     name: "Remarks",
        //     exact: true,
        //     to: "/remarksManager",
        //     iconClassName: paperclip,
        //     expand: true,
        // },

        // {
        //     name: "Discounts",
        //     exact: true,
        //     to: "/discountsManager",
        //     iconClassName: <DiscountIcon/>,
        //     expand: true,
        // },
        // {
        //     name: "Tax",
        //     exact: true,
        //     to: "/taxManager",
        //     iconClassName: tax,
        //     expand: true,
        // },

        // {
        //     name: "Users",
        //     exact: true,
        //     to: "/userManager",
        //     iconClassName: <PeopleIcon/>,
        //     expand: true,
        // },
        // {
        //     name: "Roles",
        //     exact: true,
        //     to: "/rolesManager",
        //     iconClassName: role,
        //     expand: true,
        // },
        ...(process.env.REACT_APP_LOCAL !== 'https://smash-pos-api.qrave.ph/'
            ? [
                {
                    name: "Ordering Station",
                    exact: true,
                    to: "/orderingpage",
                    iconClassName: <ShoppingCartIcon />,
                    expand: true,
                },
              ]
            : []),
    ];



    // logout handler
    // async function handleLogout() {
    //     logoutUser()
    //     navigate("/")
    //     refreshPage()
    // }
    async function handleLogout() {
        const response = await logoutUser();
        if (response.data) {
          toast.success("Logging out...")
          setTimeout(() => {
            removeUserSession();
            navigate("/");
            refreshPage();
          }, 500)
        }
    }

    const [inactive, setInactive] = useState(true);
    const [menuItems, setMenuItems] = useState([]);

    const handleExpand = (index) => {
        var list = [...menuItems];

        if (!inactive) {
            for (var i = 0; i < list.length; i++) {
                if (i !== index) {
                    list[i]["expand"] = true;
                }
            }

            list[index]["expand"] = !list[index]["expand"];

            setMenuItems(list);
        }
    };

    useEffect(() => {
        if (inactive) {
            removeActiveClassFromSubMenu();
        }

        props.onCollapse(inactive);
    }, [inactive]);

    const removeActiveClassFromSubMenu = () => {
        document.querySelectorAll(".sub-menu").forEach((el) => {
            el.classList.remove("active");
        });
    };

    useEffect(() => {
        const type = getRole();
        const user_id = getUser();
        if (type === "7") {
            setMenuItems(adminManagerItems);
        }
        else if (type === "1" && user_id === "26") {
            setMenuItems(supervisorExclusiveUser);
            // setMenuItems(adminManagerItemsWOReports);
        }
        else if (type === "1") {
            setMenuItems(supervisorItems);
            // setMenuItems(adminManagerItemsWOReports);
        }
        else if (type === "8") {
            setMenuItems(principalUsers);
            // setMenuItems(adminManagerItemsWOReports);
        }
        else if (type === "2") {
            setMenuItems(cashierItems);
        }
        else if (type === "2") {
            setMenuItems(cashierItemsWOReports);
        }


        let menuItemsList = document.querySelectorAll(".menu-item");
        menuItemsList.forEach((el, index) => {
            if (menuItems[index].name == props.active) {
                el.classList.add("active");
            }
            el.addEventListener("click", (e) => {
                const next = el.nextElementSibling;
                removeActiveClassFromSubMenu();
                menuItemsList.forEach((el) => el.classList.remove("active"));
                el.classList.toggle("active");
                if (next !== null) {
                    next.classList.toggle("active");
                }
            });
        });
    }, []);

    return (
        <div className={`side-menu ${inactive ? "inactive" : ""}`}>
            <div className="top-section">
                <div className="logo d-flex justify-content-center" >
                    <img
                        src={kaffeAldeLogo}
                        className="navbar-logo"
                        onClick={() => setInactive(!inactive)}
                    />
                </div>
            </div>

            <div className={inactive ? "main-menu" : "main-menu active-menu"}>
                {menuItems.map((menuItem, index) => (
                    <MenuItem
                        key={index}
                        name={menuItem.name}
                        exact={menuItem.exact.toString()}
                        to={menuItem.to}
                        subMenus={menuItem.subMenus || []}
                        iconClassName={menuItem.iconClassName}
                        expandManage={menuItem.expand}
                        setExpandManage={handleExpand}
                        index={index}
                        activeSub={menuItem.name === props.active}
                        onClick={(e) => {
                            if (inactive) {
                                setInactive(false);
                            }
                        }}
                    />
                ))}
            </div>
            <div className="side-menu-footer ps-2">
                {!inactive&& (
                    <div className="user-details-footer ms-4">
                        { process.env.REACT_APP_LOCAL !== 'https://smash-pos-api.qrave.ph/' ?
                            (
                                <>
                                    {/* <span>
                                        <Button
                                            className="resync-btn mb-2"
                                            onClick={handleResync}
                                        >
                                            RESYNC
                                        </Button>
                                    </span> */}
                                    <br/>
                                    {/* LOCAL */}
                                    <span className="user-type-label bolder">v 1.15.8</span>
                                </>
                            ) : (
                                <>
                                    <br/>
                                    {/* CLOUD */}
                                    <span className="user-type-label bolder">v 1.13.8</span>
                                </>
                            )

                        }
                       
                       
                        <br/>
                        <span className="navbar-user-label">{getFullNameUser()?.toUpperCase()}</span>
                        <br />
                        {/* <span className="user-type-label">{getRole()?.toUpperCase()}</span> */}
                    </div>
                )}
                <div className="logout-cont padding-bottom" onClick={() => handleLogout()}>
                    <img src={logout} className="logout-btn" />
                    <span className="logout-label">LOGOUT</span>
                </div>
            </div>
            <Modal
                maskClosable={false}
                open={showLoader}
                footer={null}
                closeIcon={false}
            >
                <Row className="d-flex justify-content-center">
                    <Title level={5}>SYNCING DATA...</Title>
                </Row>
                <Row className="d-flex justify-content-center mt-3">
                    <Spin size="large" />
                </Row>
                <Row className="d-flex justify-content-center mt-3">
                    Please do not close this window.
                </Row>
            </Modal>
        </div>
        
    );
};

export default NavbarAdmin;